import { Injectable } from '@angular/core';
import { AccessCode } from '../models';
import { CrudAPI, CrudService } from '@core/api';
import { BehaviorSubject, catchError, map, of } from 'rxjs';
// Known leak, ratcheted rather than excused: this value import puts
// DevExtreme's runtime in the NativeScript bundle, measured at 1.53 MiB (9.3%
// of vendor.js) in docs/analysis/mobile-bundle-devextreme-leak.md. The rule errors on
// any NEW devextreme import here; removing these eight disables is what fixing
// that leak means.
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root',
})
export class AccessCodeService {
  public accessCodes = new BehaviorSubject<AccessCode[]>([]);
  private accessCodeApi!: CrudAPI<AccessCode>;
  public accessCodes$ = this.accessCodes.asObservable();

  constructor(private crud: CrudService) {
    this.accessCodeApi = crud.forEndpoint('api/crud/accessCode');
  }

  public getAccessCodes() {
    return this.accessCodeApi
      .readMany('orderBy=created_at&sortedBy=desc&with=project')
      .pipe(
        map(({ data }: any) => data),
        catchError((e) => {
          notify(e.message, 'error');
          return of([] as AccessCode[]);
        })
      )
      .subscribe((x) => {
        this.accessCodes.next(x);
      });
  }

  public addAccessCode(data: any) {
    if (data.project) {
      data = {
        ...data,
        project_id: data.project.id,
      };
    }
    return this.accessCodeApi
      .createOne(data)
      .pipe(
        map(({ data }: any) => data),
        catchError((e) => {
          notify(e.message, 'error');
          return of([] as AccessCode[]);
        })
      )
      .subscribe({
        next: (res) => {
          notify(res, 'success');
        },
        complete: () => this.getAccessCodes(),
      });
  }

  public updateAccessCode(id: number, data: any) {
    if (data.project) {
      data = {
        ...data,
        project_id: data.project.id,
      };
    }
    return this.accessCodeApi
      .updateOne(id, data)
      .pipe(
        map(({ data }: any) => data),
        catchError((e) => {
          notify(e.message, 'error');
          return of([] as AccessCode[]);
        })
      )
      .subscribe();
  }
}
